export default __webpack_public_path__ + "static/Gas_Mask-64f18f825a45b305f7008886c81d6451.png";